<div class="mobi-home-header relative smMax:!mt-0 mobi-ui-margin-t-lg">
  @if (protektaOrganizationSchema(); as schema) {
    <mobi-ld-schema [schema]="schema" />
  }

  @if (entity().headerImage) {
    <div class="smMax:full-bleed relative hero-image-animation-wrapper !rounded-none">
      <mobi-media
        rounded="full"
        [entity]="entity().headerImage"
        responsiveStyle="hero_home"
        [lazy]="false"
        [animation]="false"
        class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
      ></mobi-media>
    </div>
    @if (entity().link && entity().link | extractUrl) {
      <div
        class="md:container-padding absolute z-[2] flex justify-center sm:justify-end left-0 right-0 bottom-0 translate-y-1/3 md:translate-y-1/4"
      >
        <a
          [betterRouterLink]="entity().link | extractUrl"
          class="mobi-home-header-link mobi-ui-padding-lg flex justify-between w-full sm:w-2/3 md:w-3/5 xl:w-2/5 mobi-ui-animation-trigger-hover mobi-ui-animation-appear-up-init mobi-ui-animation-appear-up-render is-delayed-500"
          [target]="entity().link?.options?.attributes?.target || '_self'"
        >
          <div
            class="mobi-ui-animation-slide-up-init mobi-ui-animation-slide-up-hover-target"
          >
            <span
              class="mobi-home-supertitle mobi-ui-font-size-200 mobi-ui-text-inked mobi-ui-font-tisa !text-white"
              >{{ entity().surtitle }}</span
            >
            <h1 class="mobi-ui-font-h2 !text-white !pb-0">
              {{ entity().link?.title }}
            </h1>
          </div>
          <div class="flex items-end">
            <mobi-ui-icon-major
              name="arrow_right"
              class="md:bg-white mb-[6px] !md:mb-[16px] mobi-ui-animation-horizontal-wiggle-hover-target"
            />
          </div>
        </a>
      </div>
    } @else if (entity()?.link?.title || entity().surtitle) {
      <div
        class="md:container-padding flex justify-center sm:justify-end translate-y-[-33%] md:translate-y-[-75%] md:mb-[-110px]"
      >
        <div
          class="mobi-home-header-link mobi-ui-padding-lg flex justify-between w-full sm:w-2/3 md:w-3/5 xl:w-2/5 mobi-ui-animation-appear-up-init mobi-ui-animation-appear-up-render is-delayed-500"
        >
          <div class="">
            @if (entity().surtitle) {
              <span
                class="mobi-home-supertitle mobi-ui-font-size-200 text-white mobi-ui-font-tisa"
                >{{ entity().surtitle }}</span
              >
            }
            @if (entity().link?.title) {
              <h1 class="mobi-ui-font-h2 !pb-0 !text-white">
                {{ entity().link?.title }}
              </h1>
            }
          </div>
        </div>
      </div>
    }
  }
</div>

@if (entity().paragraphs) {
  <div class="page-content">
    @for (paragraph of entity().paragraphs; track paragraph?.uuid ?? $index) {
      @if (paragraph) {
        <mobi-paragraph-loader
          [bundle]="paragraph.type"
          [data]="{ paragraph: paragraph }"
        />
      }
    }
  </div>
}
